import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = { class: "auth-form__container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "ds-caption ds-caption--color_dark ds-caption--size_2xl ds-caption--bold" }, /*#__PURE__*/_toDisplayString("Authorization"), -1)
const _hoisted_4 = { class: "g-row g-row--appearance_spaced g-row--space_md g-row--space_xl-xl g-row--justify_center g-row--align_center" }
const _hoisted_5 = { class: "error-label" }
const _hoisted_6 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_7 = { class: "g-cell g-cols g-cols--12 relative" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "g-cell g-cols g-cols--12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button ds-space_mt ds-space_mt--4",
    type: "submit"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "button__text" }, /*#__PURE__*/_toDisplayString('Login'))
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_VeeForm, { onSubmit: $setup.request }, {
        default: _withCtx(({ errors }) => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
              default: _withCtx(({ message }) => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(message), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_d_control_input, {
                rules: "required",
                name: "username",
                type: "text",
                staticLabel: _ctx.$t('Login'),
                modelValue: $setup.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.username) = $event))
              }, null, 8, ["staticLabel", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_d_control_input, {
                rules: "required",
                name: "password",
                type: "password",
                staticLabel: _ctx.$t('Password'),
                modelValue: $setup.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event))
              }, null, 8, ["staticLabel", "modelValue"])
            ]),
            _hoisted_8
          ])
        ]),
        _: 1
      })
    ])
  ]))
}